const ERROR_MESSAGES = {
  VERTEX_MODEL_NOT_FOUND: 'המודל לא נמצא. בדקו את הגדרות הסוכן ונסו שוב מאוחר יותר.',
  VERTEX_PERMISSION_DENIED: 'הגישה ל-Vertex AI נדחתה. בדקו הרשאות, אזור ופרויקט.',
  AGENT_NOT_FOUND: 'לא ניתן לטעון את הגדרות הסוכן.',
  SESSION_NOT_FOUND: 'הסשן לא נמצא.',
  UNKNOWN_RUNTIME_ERROR: 'אירעה שגיאה בעיבוד הבקשה. נסו שוב מאוחר יותר.',
};

export function getRuntimeErrorMessage(errorCode, source) {
  if (errorCode && ERROR_MESSAGES[errorCode]) {
    return ERROR_MESSAGES[errorCode];
  }

  if (source === 'VertexAI') {
    return ERROR_MESSAGES.VERTEX_MODEL_NOT_FOUND;
  }
  if (source === 'AgentManager') {
    return ERROR_MESSAGES.AGENT_NOT_FOUND;
  }
  if (source === 'SessionManager') {
    return ERROR_MESSAGES.SESSION_NOT_FOUND;
  }

  return ERROR_MESSAGES.UNKNOWN_RUNTIME_ERROR;
}
